<template>
  <v-dialog v-model="visible" max-width="550" persistent>
    <v-card>
      <v-card-title class="text-h6"> Ändra länk </v-card-title>

      <v-card-text>
        <v-text-field
          label="Text"
          placeholder="Länk-text"
          clearable
          outlined
          v-model="link.name_sve"
        ></v-text-field>
        <v-text-field
          label="Url"
          placeholder="https://..."
          clearable
          outlined
          v-model="link.url"
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text :to="{ name: 'art-info-links' }"> Avbryt </v-btn>

        <v-btn color="primary" :disabled="!link.name_sve || !link.url" @click="save"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ArtLinkEdit',
  props: {
    id: { type: [Number, String] },
    linkId: { type: [Number, String] },
    links: { type: Array },
  },
  data() {
    return {
      visible: true,
      link: { ...this.links.find((l) => l.id === +this.linkId) },
    }
  },
  computed: {},
  methods: {
    save() {
      this.$emit('link:edit', this.link)
      this.$router.replace({ name: 'art-info-links', params: { id: +this.id } })
    },
  },
}
</script>

<style lang="scss" scoped></style>
